import { CardPackQuality } from '@sorare/core/src/__generated__/globalTypes';

export const gradientByQuality = {
  [CardPackQuality.GOLD]: 'var(--c-gradient-gold)',
  [CardPackQuality.SILVER]: 'var(--c-gradient-silver)',
  [CardPackQuality.BRONZE]: 'var(--c-gradient-bronze)',
} as const;
